import { render, staticRenderFns } from "./LsImage.vue?vue&type=template&id=2b704cee&scoped=true&"
import script from "./LsImage.vue?vue&type=script&lang=js&"
export * from "./LsImage.vue?vue&type=script&lang=js&"
import style0 from "./LsImage.vue?vue&type=style&index=0&id=2b704cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b704cee",
  null
  
)

export default component.exports